import axios from 'axios'

export default {
    /**
     * 下载文件
     * @param url
     * @param filename
     * @returns {Promise<void>}
     */
    async downloadFile(url, filename = '下载文件') {
        try {
            const response = await axios.get(url, {
                responseType: 'blob'
            })

            // 1. 从响应头中获取 Content-Type
            const contentType = response.headers['content-type'] || 'application/octet-stream'

            // 2. 从 Content-Disposition 中提取文件名
            // 3. 创建 Blob 并触发下载
            const blob = new Blob([response.data], {type: contentType})
            const blobUrl = window.URL.createObjectURL(blob)
            const link = document.createElement('a')
            link.href = blobUrl
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link.remove()
            window.URL.revokeObjectURL(blobUrl)
        } catch (error) {
            console.error('下载失败:', error)
        }
    }
}




